import React from 'react';
import { injectIntl, type WrappedComponentProps } from 'react-intl';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { LogoWhatsapp } from '@eventbrite/legacy-eds.iconography';
import { openUrl } from './utils';
import type { UtmOptions } from './types';

interface WhatsappShareProps {
    resourceName: string;
    resourceUrl: string;
    onClick?: () => void;
    utmOptions: UtmOptions;
    className?: string;
}

const _getResourceUrl = (resourceUrl: string, utmOptions: UtmOptions) => {
    const url = new URL(resourceUrl);
    Object.entries(utmOptions).forEach(([key, value]) => {
        url.searchParams.append(key, value);
    });
    return url.toString();
};

class WhatsappShareComponent extends React.Component<
    WhatsappShareProps & WrappedComponentProps<'intl'>
> {
    _handleButtonClick() {
        const { intl, resourceName, resourceUrl, onClick, utmOptions } = this.props;
        const text = intl.formatMessage(
            {
                id: 'Check out "{resourceName}" {resourceUrl}',
                defaultMessage: 'Check out "{resourceName}" {resourceUrl}',
            },
            {
                resourceName,
                resourceUrl: _getResourceUrl(resourceUrl, utmOptions),
            },
        );
        const url = new URL('whatsapp://send');
        url.searchParams.append('text', text);

        if (onClick) {
            onClick();
        }

        openUrl(url.toString());
    }

    render() {
        const { intl } = this.props;
        return (
            <span className={this.props.className} data-testid="whatsapp-share-box-container">
                <IconButton
                    onClick={this._handleButtonClick.bind(this)}
                    iconType={<LogoWhatsapp />}
                    title={intl.formatMessage({
                        id: 'Share on Whatsapp',
                        defaultMessage: 'Share on Whatsapp',
                    })}
                />
            </span>
        );
    }
}

export const WhatsappShare = injectIntl(WhatsappShareComponent);
